/**
 * object인지 판단한다
 * @param value
 * @returns {boolean}
 */
export function isObject(value) {
  return `${value}` === '[object Object]';
}

/**
 * 타입을 반환한다
 * @param value
 * @returns {string}
 */
export function getType(value) {
  if (isObject(value)) {
    return 'object';
  }
  if (Array.isArray(value)) {
    return 'array';
  }
  if (value === null) {
    return 'null';
  }
  if (`${value}` === '[object Map]') {
    return 'map';
  }
  if (`${value}` === '[object Set]') {
    return 'set';
  }
  return typeof value;
}

/**
 * 값을 출력하기 좋은 형태의 text로 변환
 * @param value
 * @returns {*}
 */
/* eslint no-use-before-define: 0 */
export function toString(value) {
  switch (getType(value)) {
    case 'object': // property 5개만 보여준다
      return toStringObject(value);
    case 'function': // 내용을 보이지 않는다
      return 'f ()';
    case 'string': // ""로 감싼다
      return `"${value}"`;
    case 'array': // []로 감싼다 // todo 내부에 object가 있을 경우
      return `[${value}]`;
    default:
      return value;
  }
}

/**
 * object의 프로퍼티를 5개까지만 text로 변환
 * @param obj
 * @returns {string}
 */
export function toStringObject(obj) {
  const aObjectKeys = Object.keys(obj);
  const nKeysLength = aObjectKeys.length;
  const aShowingKeys = aObjectKeys.slice(0, 5);
  const aResult = aShowingKeys.reduce((memo, item) => {
    let str;
    if (obj === obj[item]) {
      str = `${item}: {...}`;
    } else {
      str = `${item}: ${isObject(obj[item]) ? '{...}' : toString(obj[item])}`;
    }
    memo.push(str);
    return memo;
  }, []);
  return `{${aResult.join(', ')}${nKeysLength > 5 ? ', ...' : ''}}`;
}

/**
 * 문자열을 통해 property를 반환한다
 * @param oRoot ex) window
 * @param sPath ex)"TMON.htLocal.htUrl"
 * @returns {*}
 */
export function getProperty(oRoot, sPath) {
  const aPath = sPath.split('.');
  return aPath.reduce((obj, sKey) => obj[sKey], oRoot);
}
